import { memo } from 'react';
import { Handle, Position } from 'react-flow-renderer';
import { RiUser3Line } from 'react-icons/ri';

const PersonNode = ({ data }) => (
    <div className="person-node">
        <RiUser3Line size={30} color="#ffffff" className="mb-2" />
        <div>{data.label}</div>

        <Handle type="target" position={Position.Top} />
        <Handle type="source" position={Position.Bottom} />
    </div>
);

export default memo(PersonNode);
